import React, { useState } from 'react';
import { api } from '../api';

export default function AuthPage({ mode, onAuthed }) {
  const isSetup = mode === 'setup';
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');

    if (isSetup && password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setSaving(true);
    try {
      const payload = { username, password };
      const result = isSetup ? await api.setupAuth(payload) : await api.login(payload);
      onAuthed(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="auth-screen">
      <form className="auth-panel" onSubmit={submit}>
        <div className="auth-brand">
          <span aria-hidden="true">S</span>
          <div>
            <h1>Flockwise</h1>
            <p className="text-muted">{isSetup ? 'Set up your farm workspace' : 'Welcome back to your flock'}</p>
          </div>
        </div>

        <div className="form-grid">
          <div className="field">
            <label>Username</label>
            <input value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" />
          </div>

          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete={isSetup ? 'new-password' : 'current-password'} />
          </div>

          {isSetup && (
            <div className="field">
              <label>Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" />
            </div>
          )}
        </div>

        {error && <div className="alert alert-danger mt-3">{error}</div>}

        <button className="btn btn-primary mt-4" type="submit" disabled={saving}>
          {saving ? 'Please wait…' : isSetup ? 'Create workspace' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}
